<div class="dialog-container bg-white rounded-3 overflow-hidden" style="height: 100%; min-width: 850px;">
  
  <!-- 💻 BARRA LATERAL DE NAVEGACIÓN (Secciones del Cliente) -->
  <div class="sidebar bg-light d-flex flex-column gap-2 border-end py-3 px-2">
    <div class="text-center mb-3">
      <span class="badge bg-dark px-3 py-2 font-monospace">AN8 JDE: {{ data.an8 }}</span>
    </div>
    
    <button type="button" class="btn btn-sm text-start fw-bold" 
            [ngClass]="activeTab === 'identidad' ? 'btn-primary' : 'btn-outline-secondary'"
            (click)="switchTab('identidad')">
      📋 Identidad Core
    </button>
    <button type="button" class="btn btn-sm text-start fw-bold" 
            [ngClass]="activeTab === 'domicilio' ? 'btn-primary' : 'btn-outline-secondary'"
            (click)="switchTab('domicilio')">
      📍 Domicilio Fiscal
    </button>
    <button type="button" class="btn btn-sm text-start fw-bold" 
            [ngClass]="activeTab === 'credito' ? 'btn-primary' : 'btn-outline-secondary'"
            (click)="switchTab('credito')">
      💰 Crédito y Pagos
    </button>
    <button type="button" class="btn btn-sm text-start fw-bold" 
            [ngClass]="activeTab === 'contactos' ? 'btn-primary' : 'btn-outline-secondary'"
            (click)="switchTab('contactos')">
      📞 Contactos Ope.
    </button>
  </div>

  <!-- 📝 CONTENIDO DEL FORMULARIO REACTIVO -->
  <div class="form-content d-flex flex-column justify-content-between p-3" [formGroup]="customerForm">
    
    <div class="overflow-auto pe-1" style="max-height: 82vh;">
      
      <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-3">
        <h3 class="h5 m-0 fw-bold text-dark">Modificar Ficha de Cliente Corporativo</h3>
        <span class="small text-muted font-monospace">Address Book Master</span>
      </div>

	    <!-- ========================================================================= -->
      <!-- PESTAÑA 1: IDENTIDAD CORE (Orden y Espacios Homologados al Alta)          -->
      <!-- ========================================================================= -->
      <div *ngIf="activeTab === 'identidad'">
        <fieldset [disabled]="!rolesPermisos.puedeEditarGenerales">
          
          <!-- FILA 1: AN8 y RÉGIMEN FISCAL (FISICAMORAL) -->
          <div class="row g-2 mb-2">
            <div class="col-md-6">
              <div class="form-floating">
                <input type="text" class="form-control bg-white fw-bold text-primary font-monospace" id="an8" formControlName="an8">
                <label for="an8">Código Corporativo AN8 (Bloqueado Nativo)</label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-floating">
                <!-- 🌟 MODIFICADO: Añadido [ngClass] para encender la alerta de inconsistencia SAT -->
                <select class="form-select" id="fisicaMoral" formControlName="fisicaMoral"
                        [ngClass]="{'is-invalid': customerForm.get('fisicaMoral')?.touched && customerForm.get('fisicaMoral')?.invalid}">
                  <!-- 🌟 DINÁMICO: Renderiza los códigos oficiales de personas físicas y morales -->
                  <option *ngFor="let tipo of tiposPersona" [value]="tipo.codigo">
                    {{ tipo.descripcion }}
                  </option>
                </select>
                <label for="fisicaMoral">Régimen Fiscal *</label>
                
                <!-- 🌟 NUEVO: Mensaje de error para el selector del Régimen -->
                <div class="invalid-feedback" *ngIf="customerForm.get('fisicaMoral')?.hasError('rfcRegimenInvalido')">
                  Régimen incongruente con la longitud del RFC.
                </div>
              </div>
            </div>
          </div>

          <!-- FILA 2: RFC y ESTATUS DE APROBACIÓN -->
          <div class="row g-2 mb-2">
            <div class="col-md-6">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="rfc" formControlName="rfc"
                      appUppercase
                      [ngClass]="{'is-invalid': customerForm.get('rfc')?.touched && customerForm.get('rfc')?.invalid}">
                <label for="rfc">RFC Oficial *</label>
                
                <!-- 🌟 ACTUALIZADO: Mensajes dinámicos según el tipo de error capturado -->
                <div class="invalid-feedback">
                  <span *ngIf="customerForm.get('rfc')?.hasError('required')">El RFC oficial es requerido.</span>
                  <span *ngIf="customerForm.get('rfc')?.hasError('pattern')">Ingrese un formato de RFC legal y válido (12 o 13 caracteres).</span>
                  <span *ngIf="customerForm.get('rfc')?.hasError('rfcRegimenInvalido')">
                    {{ customerForm.get('rfc')?.getError('rfcRegimenInvalido') }}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-floating">
                <select class="form-select" id="approvalStatus" formControlName="approvalStatus">
                  <option value="PENDIENTE">PENDIENTE</option>
                  <option value="APROBADO">APROBADO</option>
                  <option value="RECHAZADO">RECHAZADO</option>
                </select>
                <label for="approvalStatus">Estatus Aprobación</label>
              </div>
            </div>
          </div>

          <!-- FILA 3: NOMBRE COMERCIAL (Una sola línea completa para cadenas largas) -->
          <div class="row g-2 mb-2">
            <div class="col-12">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="name" formControlName="name"
                       appUppercase
                       [ngClass]="{'is-invalid': customerForm.get('name')?.touched && customerForm.get('name')?.invalid}">
                <label for="name">Nombre Comercial o Razón Social Legal*</label>
                <div class="invalid-feedback">El nombre comercial o Razón Social es requerido.</div>
              </div>
            </div>
          </div>

          <!-- FILA 5: CORREO ELECTRÓNICO Y SITIO WEB (Comparten exactamente la mitad del espacio: col-md-6 cada uno) -->
          <div class="row g-2 mb-2">
            <div class="col-md-6">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="email" formControlName="email"
                       appUppercase
                       [ngClass]="{'is-invalid': customerForm.get('email')?.touched && customerForm.get('email')?.invalid}">
                <label for="email">Correo Electrónico Central *</label>
                <div class="invalid-feedback">Ingrese un formato de correo electrónico válido.</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="webSite" formControlName="webSite"
                       appUppercase>
                <label for="webSite">Sitio Web Corporativo</label>
              </div>
            </div>
          </div>

          <!-- FILA 6: GIRO O ACTIVIDAD ECONÓMICA (Una sola línea completa para descripciones de UDCs largas) -->
          <div class="row g-2">
            <div class="col-12">
              <div class="form-floating">
                <select class="form-select" id="giroEmpresa" formControlName="giroEmpresa">
                  <option value="">-- Seleccione Actividad Económica --</option>
                  <option *ngFor="let g of girosEconomicos" [value]="g.keyRef">
                    {{ g.description }}
                  </option>
                </select>
                <label for="giroEmpresa">Giro o Actividad Económica</label>
              </div>
            </div>
          </div>

        </fieldset>
      </div>

	    <!-- ========================================================================= -->
      <!-- PESTAÑA 2: DOMICILIO FISCAL (Distribución Ergonómica en 3 Líneas)          -->
      <!-- ========================================================================= -->
      <div *ngIf="activeTab === 'domicilio'">
        <fieldset [disabled]="!rolesPermisos.puedeEditarDomicilio">
          
          <!-- 🛣️ LÍNEA 1: Calle y Número (Espacio amplio) junto a Código Postal (Espacio compacto) -->
          <div class="row g-2 mb-2">
            <div class="col-md-9">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="calleNumero" formControlName="calleNumero" style="text-transform: uppercase;"
                       appUppercase
                       [ngClass]="{'is-invalid': customerForm.get('calleNumero')?.touched && customerForm.get('calleNumero')?.invalid}">
                <label for="calleNumero">Calle, Avenida y Número *</label>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="codigoPostal" formControlName="codigoPostal"
                      appUppercase
                       [ngClass]="{'is-invalid': customerForm.get('codigoPostal')?.touched && customerForm.get('codigoPostal')?.invalid}" maxlength="5">
                <label for="codigoPostal">Código Postal (5 dígitos) *</label>
              </div>
            </div>            
          </div>


          <!-- 🏙️ LÍNEA 2: Colonia, Delegación/Municipio y País -->
          <div class="row g-2 mb-2">

            <div class="col-md-5">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="colonia" formControlName="colonia" style="text-transform: uppercase;"
                       appUppercase
                       [ngClass]="{'is-invalid': customerForm.get('colonia')?.touched && customerForm.get('colonia')?.invalid}">
                <label for="colonia">Colonia / Fraccionamiento *</label>
              </div>
            </div>            

            <div class="col-md-4">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="delegacionMnicipio" formControlName="delegacionMnicipio" style="text-transform: uppercase;"
                       appUppercase
                       [ngClass]="{'is-invalid': customerForm.get('delegacionMnicipio')?.touched && customerForm.get('delegacionMnicipio')?.invalid}">
                <label for="delegacionMnicipio">Delegación o Municipio *</label>
              </div>
            </div>

            <!-- PAÍS / REGIÓN (col-md-3 Exacto al Alta) -->
            <div class="col-md-3">
              <div class="form-floating">
                <select class="form-select" id="country" formControlName="country" (change)="onPaisCambiado($event)">
                  <option value="">-- Seleccione País --</option>
                  <option *ngFor="let p of paises" [value]="p.keyRef">
                    {{ p.description }}
                  </option>
                </select>
                <label for="country">País / Región *</label>
              </div>
            </div>
          </div>


          <!-- 📍 LÍNEA 3: Estado, Ciudad y Teléfono Contacto -->
          <div class="row g-2">

            <div class="col-md-4">
              <div class="form-floating">
                <!-- CASO A: Selector Desplegable (México / USA) -->
                <select *ngIf="mostrarDesplegableEstado" class="form-select text-uppercase" id="estadoSelect" formControlName="estado"
                        [ngClass]="{'is-invalid': customerForm.get('estado')?.touched && customerForm.get('estado')?.invalid}">
                  <option value="">-- Seleccione Estado --</option>
                  <option *ngFor="let est of estados" [value]="est.description">
                    {{ est.description }}
                  </option>
                </select>

                <!-- CASO B: Caja de Captura Libre (Otros Países) -->
                <input *ngIf="!mostrarDesplegableEstado" type="text" class="form-control text-uppercase" id="estadoInput" formControlName="estado"
                      style="text-transform: uppercase;"
                      (input)="customerForm.get('estado')?.setValue(customerForm.get('estado')?.value?.toUpperCase(), {emitEvent: false})"
                      [ngClass]="{'is-invalid': customerForm.get('estado')?.touched && customerForm.get('estado')?.invalid}"
                      placeholder="Provincia o Estado">
                <label for="estadoSelect">Estado / Entidad / Provincia *</label>
                <div class="invalid-feedback">El estado o provincia es obligatorio.</div>
              </div>
            </div>

            <!-- 🌟 AGREGADO: NUEVO CAMPO CIUDAD (Alineado simétricamente) -->
            <div class="col-md-4">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="ciudad" formControlName="ciudad"
                       appUppercase
                       [ngClass]="{'is-invalid': customerForm.get('ciudad')?.touched && customerForm.get('ciudad')?.invalid}">
                <label for="ciudad">Ciudad *</label>
                <div class="invalid-feedback">La ciudad es requerida.</div>
              </div>
            </div>            

            <!-- TELÉFONO DE CONTACTO PRINCIPAL (col-md-3 Exacto al Alta) -->
            <div class="col-md-4">
              <div class="form-floating">
                <input type="text" class="form-control" id="telefonoDF" formControlName="telefonoDF"
                      (keypress)="soloNumeros($event)"
                      [ngClass]="{'is-invalid': customerForm.get('telefonoDF')?.touched && customerForm.get('telefonoDF')?.invalid}"
                      placeholder="3312345678">
                <label for="telefonoDF">Teléfono Contacto</label>
                <div class="invalid-feedback">Debe contener exactamente 10 dígitos numéricos para México.</div>
              </div>
            </div>
          </div>
          
        </fieldset>
      </div>

	    <!-- ========================================================================= -->
      <!-- PESTAÑA 3: PARÁMETROS DE CRÉDITO Y TESORERÍA (Rejilla Balanceada)          -->
      <!-- ========================================================================= -->
      <div *ngIf="activeTab === 'credito'">
        <fieldset [disabled]="!rolesPermisos.puedeEditarCredito">
          

          <!-- FILA 2: LÍMITES, PLAZOS Y AUDITORÍA -->
          <div class="row g-2">
            <div class="col-md-4">
              <div class="form-floating">
                <input type="text" class="form-control" id="diasCredito" formControlName="diasCredito" placeholder="0">
                <label for="diasCredito">Días de Crédito Autorizados</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-floating">
                <select class="form-select" id="currencyCode" formControlName="currencyCode">
                  <option *ngFor="let moneda of tiposMoneda" [value]="moneda">{{ moneda }}</option>
                </select>
                <label for="currencyCode">Divisa Base</label>
              </div>
            </div>
			      <!-- FECHA DE ALTA (Mapeo Simétrico Protegido) -->
            <div class="col-md-4">
              <div class="form-floating">
                <!-- 💡 readonly bloquea la edición pero permite que Angular pinte el valor -->
                <input type="datetime-local" class="form-control bg-light" id="fechaAprobacion" formControlName="fechaAprobacion" readonly>
                <label for="fechaAprobacion">Fecha de Alta (Sistema)</label>
              </div>
            </div>
          </div>

        </fieldset>
      </div>

      <!-- ========================================================================= -->
      <!-- PESTAÑA 4: DIRECTORIO DE CONTACTOS OPERATIVOS (Confirmación de Cierre)     -->
      <!-- ========================================================================= -->
      <div *ngIf="activeTab === 'contactos'">
        <fieldset [disabled]="!rolesPermisos.puedeEditarContactos">
          
          <!-- FILA 1: CONTACTO COBRANZA (CxC) -->
          <div class="text-secondary fw-bold mb-2 small" style="font-size: 0.78rem; letter-spacing: 0.5px;">CONTACTO COBRANZA (CxC)</div>
          <div class="row g-2 mb-3">
            <div class="col-md-4">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="nombreContactoCxC" formControlName="nombreContactoCxC"
                appUppercase>                
                <label for="nombreContactoCxC">Nombre Completo</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="emailContactoCxC" formControlName="emailContactoCxC"
                appUppercase
                [ngClass]="{'is-invalid': customerForm.get('emailContactoCxC')?.touched && customerForm.get('emailContactoCxC')?.invalid}">
                <label for="emailContactoCxC">Correo Electrónico</label>
                <div class="invalid-feedback">Ingrese un formato de correo electrónico válido.</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-floating">
                <input type="text" class="form-control" id="telefonoContactoCxC" formControlName="telefonoContactoCxC" (keypress)="soloNumeros($event)" maxlength="10">
                <label for="telefonoContactoCxC">Teléfono Contacto</label>
              </div>
            </div>
          </div>

          <!-- FILA 2: CONTACTO DE OPERACIONES / LOGÍSTICA -->
          <div class="text-secondary fw-bold mb-2 small" style="font-size: 0.78rem; letter-spacing: 0.5px;">CONTACTO DE OPERACIONES / LOGÍSTICA</div>
          <div class="row g-2 mb-3">
            <div class="col-md-4">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="nombreContactoPedidos" formControlName="nombreContactoPedidos"
                appUppercase>
                <label for="nombreContactoPedidos">Nombre Completo</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="emailContactoPedidos" formControlName="emailContactoPedidos" 
                appUppercase
                [ngClass]="{'is-invalid': customerForm.get('emailContactoPedidos')?.touched && customerForm.get('emailContactoPedidos')?.invalid}">
                <label for="emailContactoPedidos">Correo Electrónico</label>
                <div class="invalid-feedback">Ingrese un formato de correo electrónico válido.</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-floating">
                <input type="text" class="form-control" id="telefonoContactoPedidos" formControlName="telefonoContactoPedidos" (keypress)="soloNumeros($event)" maxlength="10">
                <label for="telefonoContactoPedidos">Teléfono Contacto</label>
              </div>
            </div>
          </div>

          <!-- FILA 3: CONTACTO COMERCIAL / VENTAS -->
          <div class="text-secondary fw-bold mb-2 small" style="font-size: 0.78rem; letter-spacing: 0.5px;">CONTACTO COMERCIAL / VENTAS</div>
          <div class="row g-2">
            <div class="col-md-4">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="nombreContactoVentas" formControlName="nombreContactoVentas"
                appUppercase>
                <label for="nombreContactoVentas">Nombre Completo</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="emailContactoVentas" formControlName="emailContactoVentas" 
                appUppercase
                [ngClass]="{'is-invalid': customerForm.get('emailContactoVentas')?.touched && customerForm.get('emailContactoVentas')?.invalid}">
                <label for="emailContactoVentas">Correo Electrónico</label>
                <div class="invalid-feedback">Ingrese un formato de correo electrónico válido.</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-floating">
                <input type="text" class="form-control" id="telefonoContactoVentas" formControlName="telefonoContactoVentas" (keypress)="soloNumeros($event)" maxlength="10">
                <label for="telefonoContactoVentas">Teléfono Contacto</label>
              </div>
            </div>
          </div>



          <!-- 🚀 FILA 4: CONTACTO DE COMPRAS / ADQUISICIONES -->
          <div class="text-secondary fw-bold mb-2 small" style="font-size: 0.78rem; letter-spacing: 0.5px;">CONTACTO DE COMPRAS / ADQUISICIONES</div>
          <div class="row g-2 mb-3">
            <div class="col-md-4">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="nombreContactoCompras" formControlName="nombreContactoCompras" appUppercase>
                <label for="nombreContactoCompras">Nombre Completo</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="emailCompras" formControlName="emailCompras" appUppercase
                [ngClass]="{'is-invalid': customerForm.get('emailCompras')?.touched && customerForm.get('emailCompras')?.invalid}">
                <label for="emailCompras">Correo Electrónico</label>
                <div class="invalid-feedback">Ingrese un formato de correo electrónico válido.</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-floating">
                <input type="text" class="form-control" id="telefonoCompras" formControlName="telefonoCompras" (keypress)="soloNumeros($event)" maxlength="10">
                <label for="telefonoCompras">Teléfono Contacto</label>
              </div>
            </div>
          </div>

          <!-- 🚀 FILA 5: CONTACTO DE CUENTAS POR PAGAR (CxP) -->
          <div class="text-secondary fw-bold mb-2 small" style="font-size: 0.78rem; letter-spacing: 0.5px;">CONTACTO DE CUENTAS POR PAGAR (CxP)</div>
          <div class="row g-2">
            <div class="col-md-4">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="nombreContactoCxP01" formControlName="nombreContactoCxP01" appUppercase>
                <label for="nombreContactoCxP01">Nombre Completo</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-floating">
                <input type="text" class="form-control text-uppercase" id="emailCxP01" formControlName="emailCxP01" appUppercase
                [ngClass]="{'is-invalid': customerForm.get('emailCxP01')?.touched && customerForm.get('emailCxP01')?.invalid}">
                <label for="emailCxP01">Correo Electrónico</label>
                <div class="invalid-feedback">Ingrese un formato de correo electrónico válido.</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-floating">
                <input type="text" class="form-control" id="telefonoCxP01" formControlName="telefonoCxP01" (keypress)="soloNumeros($event)" maxlength="10">
                <label for="telefonoCxP01">Teléfono Contacto</label>
              </div>
            </div>
          </div>


        </fieldset>
      </div>

    </div>

    <!-- 📥 BOTONERA DE ACCIÓN INFERIOR -->
    <div class="d-flex justify-content-end gap-2 border-top pt-3 mt-3">
      <button type="button" class="btn btn-sm btn-outline-secondary px-4 fw-semibold" (click)="onCancel()">
        Cancelar
      </button>
      <button type="button" class="btn btn-sm text-white px-4 shadow-sm" 
              (click)="onSave()"
              [style.opacity]="customerForm.invalid ? '0.5' : '1'"
              style="background-color: #0d6efd; font-weight: 500;">
        💾 Guardar Cambios
      </button>
    </div>

  </div>
</div>